import { TypedContainer } from "./_Base";
export class AnimationContainer extends TypedContainer {
  set_content(content) {
    super.set_content(content);
  }
  setTimelineBuilder(timeline_builder) {
    return this.set_content(timeline_builder);
  }
  timelineBuilder() {
    return this.content();
  }
  coreContentCloned() {
    if (this._content) {
      return this._content.clone();
    }
  }
}
